import './LoadingScreen.css';

interface LoadingScreenProps {
  label?: string;
  // 'inline' fills its parent container, 'overlay' covers the viewport,
  // 'compact' is small enough to sit inside a button.
  variant?: 'inline' | 'overlay' | 'compact';
}

export function LoadingScreen({ label, variant = 'inline' }: LoadingScreenProps) {
  return (
    <div className={`loading-screen loading-screen-${variant}`}>
      <svg className="loading-screen-media" viewBox="0 0 24 24">
        <circle
          className="loading-screen-spinner-circle"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
          fill="none"
        />
      </svg>
      {label && <p className="loading-screen-label">{label}</p>}
    </div>
  );
}
